import React, { useCallback } from 'react';
import JiraFullscreenButton from '@atlassian/jira-fullscreen-button/src/index.tsx';
import { View } from '@atlassian/jira-software-view-settings/src/common/types/constant.tsx';
import {
	useViewSettingsActions,
	useIsFullscreen,
} from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { useIsIncrementPlanningBoard } from '../../../state/state-hooks/capabilities/index.tsx';

interface Props {
	boardId: number;
	shouldRenderContent?: boolean;
}

const getFullscreenRefs = (): (HTMLElement | null)[] =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
	Array.from(document.querySelectorAll('[data-fullscreen-id]')) as (HTMLElement | null)[];

export const FullscreenButton = ({ boardId, shouldRenderContent }: Props) => {
	const { setIsFullscreen } = useViewSettingsActions();
	const isFullscreen = useIsFullscreen();
	const view = useIsIncrementPlanningBoard() ? View.INCREMENT_PLANNING_BOARD : View.BOARD;

	const handleFullscreenToggle = useCallback(
		(wasFullscreen: boolean) => {
			setIsFullscreen({ boardId, isFullscreen: !wasFullscreen, view });
		},
		[boardId, setIsFullscreen, view],
	);

	return (
		<JiraFullscreenButton
			testId="software-board.header.fullscreen-button.fullscreen-button"
			getCustomRefs={getFullscreenRefs}
			withContainerStyles={false}
			onToggle={handleFullscreenToggle}
			isFullscreen={isFullscreen}
			shouldRenderContent={shouldRenderContent}
		/>
	);
};
